export function thirdParty(config) {
  return {
    data: config.data ? config.data : [],
    scripts: [],

    init() {
      try {
        console.log("third party script loaded");
        const tempScripts = JSON.parse(JSON.stringify(this.data));
        if (Array.isArray(tempScripts)) {
          this.scripts.push(...tempScripts);
        }
        // eslint-disable-next-line no-restricted-syntax
        for (const script of this.scripts) {
          // https://grrr.tech/posts/create-dom-node-from-html-string/
          const findHead = document.querySelector("head");
          // console.log("script.script_delay", script);
          if (script.script_delay && script.script_content && findHead) {
            setTimeout(() => {
              // findHead.insertAdjacentHTML("beforeend", script.script_content);
              const node = document.createRange().createContextualFragment(script.script_content);
              document.head.prepend(node);
              // console.log(script.script_name, "was added");
            }, parseInt(script.script_delay, 10) * 1000 || 10);
          }

          if (!script.script_delay && script.script_content && findHead) {
            setTimeout(() => {
              // findHead.insertAdjacentHTML("beforeend", script.script_content);
              const node = document.createRange().createContextualFragment(script.script_content);
              document.head.prepend(node);
              console.log(script.script_name, "was added");
            }, 10);
          }
        }
      } catch (e) {
        console.error("Error while adding third party script");
        this.scripts = [];
      }
    },

    openModal(data) {
      this.show = data;
    }
  };
}
